import { motion } from 'motion/react';

export const CreateCohortButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <motion.div
      className="flex justify-end mt-6"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.4 }}
    >
      <button
        className="bg-primary-background-default hover:bg-primary-background-hover text-black font-medium px-4 py-2 rounded-full text-sm border border-stroke-on-dark-subdued"
        onClick={onClick}
      >
        Run
      </button>
    </motion.div>
  );
};
